var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullhorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12156_66376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.275 0H13.0875L12.9469 0.125L11.0063 1.82812C9.57812 3.08125 7.77187 3.81875 5.875 3.925L4.4875 4H0.5H0V4.5V10.5V11H0.5H2V15.5V16H2.5H5.5H6V15.5V11.0844C7.85 11.2156 9.60938 11.9469 11.0063 13.1719L12.9469 14.875L13.0875 15H13.275H13.5H14V14.5V0.5V0H13.5H13.275ZM5 11.0281V15H3V11H4.4875L5 11.0281ZM11.6656 2.57812L13 1.40625V13.5938L11.6656 12.4219C10.3406 11.2594 8.725 10.4937 7 10.2V4.8C8.72188 4.50625 10.3406 3.74062 11.6656 2.57812ZM6 4.91875V10.0844C5.975 10.0844 5.95312 10.0813 5.92812 10.0813L4.52812 10H4.51562H4.50313H1V5H4.5H4.5125H4.525L5.925 4.92188C5.95 4.92188 5.97187 4.91875 5.99687 4.91875H6ZM16 6H15V6.5V8.5V9H16V8.5V6.5V6Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12156_66376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullhorn);
export default __webpack_public_path__ + "static/media/bullhorn.d889e08059ae3a2f51c813f7c8fd1dcd.svg";
export { ForwardRef as ReactComponent };